import {Paper, Tab} from "@mui/material";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {LocalizedText} from "./LocalizedText";
import {useState} from "react";
import {makeStyles} from "@mui/styles";
import {LocalizedSubtitles} from "./LocalizedSubtitles";

const useStyles = makeStyles((theme) => ({
    content: {
        height: "100%",
        width: "100%"
    }
}));

export const LocalizedLanguages: {[language: string]: string} = {
    englishUS: "US English",
    arabic: "Arabic",
    brazilianPortuguese: "Brazilian Portuguese",
    bulgarian: "Bulgarian",
    dutch: "Dutch",
    french: "French",
    german: "German",
    greek: "Greek",
    hungarian: "Hungarian",
    italian: "Italian",
    mexicanSpanish: "Mexican Spanish",
    polish: "Polish",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    chineseSimplified: "Chinese, Simplified",
    chineseTraditional: "Chinese, Traditional",
};

interface ILocalization {
    project: string
}
export function Localization({project}: ILocalization) {
    const classes = useStyles();
    const [tab, setTab] = useState("text");

    return (
        <Paper className={classes.content}>
            <TabContext value={tab}>
                <TabList onChange={(event, tab) => setTab(tab)} sx={{margin: 1}}>
                    <Tab value="text" label="Localized Text"/>
                    <Tab value="subTitles" label="Subtitles"/>
                </TabList>
                <TabPanel value="text" sx={{height: "100%"}}>
                    <LocalizedText project={project}/>
                </TabPanel>
                <TabPanel value="subTitles" sx={{height: "100%"}}>
                    <LocalizedSubtitles project={project}/>
                </TabPanel>
            </TabContext>
        </Paper>
    );
}